import { subscribeRaidDomainSignals } from '../../raid-control/api/raidDomainSignals.js';

export function subscribeRaidResultLiveSignal({ unionId, seasonId, seasonNo, onChange }) {
  return subscribeRaidDomainSignals({
    unionId, seasonId, seasonNo,
    onReconnect: () => onChange?.({ seasonId, changeType: 'resync' }),
    onChange: signal => { if (signal.domain === 'results') onChange?.(signal); },
  });
}
